import MenuItem from '@mui/material/MenuItem';

import { useDeviceDetailsHook } from 'features/device/device-details/hooks/device-details-hook';

import 'features/device/device-details/views/device-commands-detail-settings/device-command-details-popup-settings.component.scss';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import SelectField from 'shared/components/formFields/select-field';
import ViewingModeController from 'shared/components/viewing-mode-controller/viewing-mode-controller';
import defaultValues from 'shared/constants/defaultValues';

import { DomipFunction } from 'features/device/domain/models/domip-function';
import { DeviceCommandType } from 'features/device/models/device-command-type';
import styles from './domip-output-settings.module.scss';

const DomipOutputSettings = (): React.JSX.Element => {
  const { t } = useTranslation('deviceDetails');

  const { currentViewingMode, currentDevice } = useDeviceDetailsHook();

  const { control } = useFormContext();

  const currentDeviceCommand = currentDevice?.commands?.find((entry) => entry.type === DeviceCommandType.DomipFunction);

  const domipFunctionOptions = [
    <MenuItem data-testid={`domip-function-default-value`} key={`domip-function-default-value`} value={defaultValues.defaultSelectValue}>
      {defaultValues.defaultSelectValue}
    </MenuItem>,
    <MenuItem data-testid={`domip-function-deso-doorcontrol`} key={`domip-function-deso-doorcontrol`} value={DomipFunction.DesoDoorControl}>
      {t(`info.domipFunction.${DomipFunction.DesoDoorControl}`)}
    </MenuItem>,
  ];

  return (
    <>
      {currentViewingMode === 'viewing' && (
        <div className={styles.viewingContainer}>
          <Typography variant="subtitle1">{`${t('info.function')}:`}</Typography>
          <Typography variant="subtitle1">
            {currentDeviceCommand ? t(`info.domipFunction.${currentDeviceCommand.action}`) : defaultValues.defaultSelectValue}
          </Typography>
        </div>
      )}
      {currentViewingMode === 'editing' && (
        <div className={styles.functionSelect}>
          <ViewingModeController
            viewingMode={currentViewingMode}
            name="commands[0].action"
            control={control}
            label={t('info.function')}
            render={({ field }) => (
              <SelectField
                {...field}
                disabled={currentViewingMode !== 'editing'}
                inputProps={{
                  'data-testid': 'DomipFunction',
                  disabled: currentViewingMode !== 'editing',
                }}
                id="DomipFunction"
                label={t('info.function')}
                variant="outlined"
                className="form-field"
                data-testid="DomipFunctionSelect"
                value={field.value ?? defaultValues.defaultSelectValue}
              >
                {domipFunctionOptions}
              </SelectField>
            )}
          />
        </div>
      )}
    </>
  );
};

export default DomipOutputSettings;
